import { render, staticRenderFns } from "./SelectDocuments.vue?vue&type=template&id=8da33214&scoped=true&lang=pug"
import script from "./SelectDocuments.vue?vue&type=script&lang=js"
export * from "./SelectDocuments.vue?vue&type=script&lang=js"
import style0 from "./SelectDocuments.vue?vue&type=style&index=0&id=8da33214&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da33214",
  null
  
)

export default component.exports